module["exports"] = [
  "ASC",
  "MMC",
  "QSC",
];
